
const danielPhoto = "https://static.readdy.ai/image/b38d0475ce589291eceb67661996448f/2a2558c7aa812b59f3632681c7e8edfc.png";
const whatsappLink = "https://wa.me/5511922305730?text=Olá%2C%20Daniel!%20Tenho%20um%20imóvel%20em%20Brasília%20e%20gostaria%20de%20uma%20avaliação%20gratuita.";

const CTAProprietarios = () => (
  <section className="py-24 bg-gradient-to-br from-teal-600 via-emerald-600 to-teal-700 text-white relative overflow-hidden">
    <div className="absolute inset-0 opacity-10">
      <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl" />
    </div>

    <div className="container mx-auto px-4 relative z-10">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Foto */}
          <div className="flex justify-center order-2 lg:order-1">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="relative group cursor-pointer">
              <div className="absolute -inset-8 bg-white/20 rounded-full blur-3xl group-hover:bg-white/30 transition-all" />
              <div className="relative">
                <img
                  src={danielPhoto}
                  alt="Daniel Carvalho - Especialista Imobiliário Brasília"
                  className="w-72 h-auto object-contain drop-shadow-2xl group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 bg-white text-teal-700 px-5 py-2 rounded-full shadow-xl flex items-center gap-2 group-hover:scale-110 transition-transform whitespace-nowrap">
                  <i className="ri-whatsapp-fill text-lg text-green-500"></i>
                  <span className="font-bold text-sm">Fale Comigo Agora</span>
                </div>
              </div>
            </a>
          </div>

          {/* Conteúdo */}
          <div className="text-center lg:text-left order-1 lg:order-2">
            <span className="inline-block bg-white/20 border border-white/30 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              🏠 Proprietários em Brasília, DF
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Pronto para Vender ou Alugar seu Imóvel?
            </h2>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Entre em contato agora e receba uma avaliação gratuita do seu imóvel em Brasília. Sem compromisso, sem burocracia.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-10">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all hover:shadow-xl hover:scale-105 text-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-2xl text-green-500"></i>
                Avaliação Gratuita
              </a>
              <a
                href="#formulario"
                className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-bold hover:bg-white/20 transition-all border border-white/30 text-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-file-list-3-line text-xl"></i>
                Cadastrar Imóvel
              </a>
            </div>

            <div className="grid grid-cols-3 gap-4">
              {[
                { icon: 'ri-timer-flash-line', title: 'Venda Rápida', sub: 'Média de 28 dias' },
                { icon: 'ri-shield-check-line', title: 'Segurança Total', sub: 'Processo 100% seguro' },
                { icon: 'ri-trophy-line', title: 'Melhor Preço', sub: 'Avaliação precisa' },
              ].map((item, i) => (
                <div key={i} className="bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/20 text-center">
                  <i className={`${item.icon} text-3xl mb-2 block`}></i>
                  <h3 className="font-bold text-sm mb-1">{item.title}</h3>
                  <p className="text-white/80 text-xs">{item.sub}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default CTAProprietarios;
